import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static values = {
    period: Number    // timeout in Seconds
  }

  connect() {
    console.log("Hello, Timeout!", this.element);

    Window.set_timeout_window(this.periodValue);
  }
}
